// Build-time configuration baked in by Vite (see deploy.sh / .env).
// The deployed stack is per-environment, so the environment is a fixed
// property of the build — not switchable at runtime.

export const API_BASE = import.meta.env.VITE_API_BASE_URL || '';

export const ENVIRONMENT: 'development' | 'production' =
  import.meta.env.VITE_ENVIRONMENT === 'production' ? 'production' : 'development';

export const ENVIRONMENT_LABEL = ENVIRONMENT === 'production' ? 'Production' : 'Development';

export const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID || '';
